import { render, staticRenderFns } from "./SupplierOrderCreate.vue?vue&type=template&id=a12a04de"
import script from "./SupplierOrderCreate.vue?vue&type=script&lang=js"
export * from "./SupplierOrderCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports